import { icons } from "assets/AssetHelper";
import dayjs from "dayjs";

export const detailsData = (t, { data }) => [
  {
    head: t("gift_cards.details"),
    icon: icons?.details,
    details: [
      {
        label: t("between_zones_fees.origin_zone"),
        name: data?.origin_zone?.name,
      },
      {
        label: t("between_zones_fees.destination_zone"),
        name: data?.destination_zone?.name,
      },
      {
        label: t("common.city"),
        name: data?.city?.name,
      },
    ],
  },
  {
    head: t("between_zones_fees.fees"),
    icon: icons?.fees,
    details: [
      {
        label: t("between_zones_fees.delivery_fees"),
        name: `${data?.delivery_fees} SAR`,
      },
    ],
  },
  {
    head: t("gift_cards.dates"),
    icon: icons?.dates,
    details: [
      {
        label: t("gift_cards.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY hh:mm"),
      },
      {
        label: t("gift_cards.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY hh:mm"),
      },
    ],
  },
];
